import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';
import simpleLoading from 'simple-loading';
import simpleDialog from 'simple-dialog';

Component('tr-repository-new-doc-menu', {
  mixins: [eventListenerMixin],

  connected() {
    this.menu = this.querySelector('tr-menu');
    this.listenTo(this.menu, 'tao:closed', () => simpleLoading.destroy());
  },

  ready() {
    const $import = $(this).find('#link-tencent-docs-import');
    if ($import.length) this.initUploader($import);
  },

  initUploader($link) {
    const uploader = window.simple.uploader({
      url: $link.data('url'),
      params: {
        authenticity_token: $('meta[name=csrf-token]').attr('content'),
      },
    });

    uploader
      .on('beforeupload', (e, file) => {
        if (file.size && file.size / 1024 / 1024 > 20) {
          simpleDialog.message({
            content: '抱歉，最大只支持 20 MB。',
            width: 400,
          });
          return false;
        }

        simpleLoading({
          type: 'tiny',
          msg: '正在上传文件',
        });
        return true;
      })
      .on('uploadcomplete', simpleLoading.destroy)
      .on('uploadsuccess', this.initPusher.bind(this));

    $link.find('input').on('change', (e) => {
      uploader.upload(e.target.files);
    });
  },

  initPusher() {
    simpleLoading.destroy();
    simpleLoading({
      type: 'tiny',
      msg: '正在导入文件',
    });

    window.tower
      .tempPusher(`${process.env.PUSHER_CHANNEL_PREFIX}${window.tower.me.id}`)
      .bind('pusher:subscription_error', () => {
        simpleLoading.destroy();
        simpleDialog.message({
          content: '通知服务连接失败，可能无法导入文件，请刷新尝试或与客服联系。',
        });
      })
      .bind('repository_tencent_documents_import', (data) => {
        if (data.success) window.location.href = data.target_url;
        simpleLoading.destroy();
        if (data.msg) simpleDialog.message({ content: data.msg });
      });
  },

  disconnected() {
    if (window.tower.tempPusherSocket) window.tower.tempPusherSocket.disconnect();
    window.tower.tempPusherSocket = null;
  },
});
